import { Response } from '../response'
import { Doctor, DoctorOpinion, DoctorState, UserInfo } from './types'

export const state: DoctorState = {
  loading: false,
  loadingInfo: false,
  loadingAddDaySchedule: false,
  loadingDoctorsInModule: true,
  doctor: {} as Doctor,
  requestSent: false,
  userInfo: {} as UserInfo,
  userStatus: {} as Response<Doctor>,
  opinions: [] as DoctorOpinion[]
}
